import { Modal } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { ImportTutorsForm } from '../forms/ImportTutorsForm';

export type PersonAssignments = Record<number, string>;

type ImportPersonsModalProps = {
  open: boolean;
  classIds: number[];
  onImport: (x: PersonAssignments | null) => void;
  onClose: () => void;
};

export const ImportTutorsModal = ({ open, classIds, onImport, onClose }: ImportPersonsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal key={'import.persons'} isOpen={open} onRequestClose={onClose} title={t('procuratImport.importClasses')}>
      <ImportTutorsForm classIds={classIds} onImport={onImport} onClose={onClose} />
    </Modal>
  );
};
